import "./index.scss";

interface VendorToastProps {
  message: string;
  type?: "success" | "error" | "info";
}

export const VendorToast = ({ message, type = "info" }: VendorToastProps) => {
  if (!message) return null;

  return (
    <div className={`vendor-toast ${type}`} role="status" aria-live="polite">
      {message}
    </div>
  );
};
